import { Link } from "react-router-dom";
import { ASSETS, BRAND } from "@/lib/brand";

export default function Hero() {
  return (
    <section
      data-testid="home-hero"
      className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden"
    >
      {/* Decorative diagonal texture */}
      <div className="absolute inset-0 bg-cream" />
      <div className="absolute -top-32 -left-32 h-96 w-96 rounded-full bg-taupe/15 blur-3xl" />
      <div className="absolute bottom-0 right-0 h-[28rem] w-[28rem] rounded-full bg-bronze/10 blur-3xl" />

      <div className="container-page relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {/* Left: copy */}
          <div className="lg:col-span-7 order-2 lg:order-1">
            <div className="reveal eyebrow mb-6 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-bronze" />
              {BRAND.name} · {BRAND.founder}
            </div>
            <h1 className="reveal font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-[5.5rem] text-ink leading-[1.02] tracking-tight">
              Unlock Your <span className="italic text-bronze">Real Estate</span> Portfolio Potential.
            </h1>
            <p className="reveal mt-8 font-serif italic text-xl md:text-2xl text-olive">
              Embark on A Homely Abode Journey
            </p>
            <p className="reveal mt-4 max-w-xl text-base md:text-lg leading-relaxed text-ink_soft/80 font-light">
              Build, Grow, and Thrive with a Trusted Consultant & Marketer. Whether you're a
              first-time buyer, an ambitious investor, or a discerning homeowner — my dedicated
              consulting and marketing services will elevate your property portfolio, tailored to you.
            </p>

            <div className="reveal mt-10 flex flex-wrap gap-4">
              <a
                href={BRAND.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-cta-journey"
                className="btn-primary"
              >
                Start Your Property Journey
              </a>
              <Link
                to="/listings"
                data-testid="hero-cta-listings"
                className="btn-secondary"
              >
                View Listings
              </Link>
            </div>

          </div>

          {/* Right: portrait */}
          <div className="lg:col-span-5 order-1 lg:order-2 relative reveal">
            <div className="relative">
              <div className="absolute -inset-6 border border-bronze/30 -z-0 hidden md:block" />
              <div className="relative aspect-[4/5] overflow-hidden bg-beige">
                <img
                  src={ASSETS.portraits.hero}
                  alt="Kiap Yong — Founder of A Homely Abode"
                  className="absolute inset-0 h-full w-full object-cover object-top"
                />
                {/* Subtle vignette to blend white photo background into cream */}
                <div className="absolute inset-0 bg-gradient-to-t from-cream/40 via-transparent to-transparent" />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-ink text-cream p-5 md:p-6 max-w-[15rem]">
                <div className="text-[0.65rem] tracking-[0.25em] uppercase text-taupe">
                  Founder
                </div>
                <div className="font-serif text-2xl mt-1">Kiap Yong</div>
                <div className="text-xs text-cream/60 mt-1">
                  A Homely Abode · Singapore
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
